// extracted by mini-css-extract-plugin
export default {"button":"RoundedButton-module__button__wDqNp"};